var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-350b4003.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-42970741.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M28.692 28.692a8.15 8.15 0 0 1-3.035 2.078C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23a8.15 8.15 0 0 1-3.034-2.078L16 16l12.692 12.692Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16.666.01 16 16 15.334.01c.222-.005.444-.008.666-.01.222.002.444.005.666.01Zm12.788 4.218L16 16 28.135 2.762a9.13 9.13 0 0 1 1.319 1.466ZM3.864 2.76 16 16 2.552 4.233A9.162 9.162 0 0 1 3.864 2.76ZM31.997 15c.004.344.004.683 0 1.016.004.323.004.65-.001.984L16 16l15.997-1ZM.004 15 16 16 .003 17a39.42 39.42 0 0 1 0-1.017C0 15.661 0 15.333.004 15Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagReu = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagReu_default = SvgFlagReu;
export {
  FlagReu_default as default
};
